import { create } from "zustand";
import { api, ApiError, setActiveTenantHeader } from "@/lib/api.js";

type AuthUser = { id: string; email: string };

type AuthStore = {
  user: AuthUser | null;
  checked: boolean;
  activeTenantId: string | null;
  loginAdmin: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkSession: () => Promise<void>;
  setActiveTenantId: (id: string) => void;
};

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  checked: false,
  activeTenantId: null,

  loginAdmin: async (email, password) => {
    const res = await api.post<{ ok: boolean; user: AuthUser }>(
      "/api/auth/login/admin",
      { email, password }
    );
    set({ user: res.user });
  },

  logout: async () => {
    await api.post("/api/auth/logout").catch(() => {});
    setActiveTenantHeader(null);
    set({ user: null, activeTenantId: null });
  },

  checkSession: async () => {
    try {
      const res = await api.get<{
        authenticated: boolean;
        user_type?: string;
        user?: AuthUser;
      }>("/api/auth/session");
      // Only accept admin sessions (not super_admin)
      const valid = res.authenticated && res.user_type === "admin";
      set({ user: valid ? (res.user ?? null) : null, checked: true });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        set({ user: null, checked: true });
      } else {
        set({ checked: true });
      }
    }
  },

  setActiveTenantId: (id: string) => {
    setActiveTenantHeader(id);
    set({ activeTenantId: id });
  },
}));
